<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        
        <div class="card mb-4">
            <div class="card-body">
                
                <div class="row">
                    <div v-if="isLoading" class="loader-wrapper">
                        <div class="loader"></div>
                    </div>
                    <div v-else>
                        <h4 class="mb-5">Add Subcription Plan</h4>
                        <form class="mb-3" @submit.prevent="addSubscription">

                            <div class="mb-3">
                                <label class="form-label d-block">Select available plan</label>
                                <div class="form-check form-check-inline mt-3">
                                    <input class="form-check-input" type="radio" v-model="planCode" value="SWPCORE">
                                    <label class="form-check-label" for="inlineRadio1">Safeworkpro safety software subscription - Monthly subscription </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" v-model="planCode" value="SWPCOREAnnaual">
                                    <label class="form-check-label" for="inlineRadio2">Safeworkpro safety software subscription - Annually  subscription </label>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label">Site Name</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Enter site name" required v-model="sitename" autofocus />
                                    <span class="input-group-text">.safeworkpro.com</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md">
                                    <div class="mb-3 form-password-toggle">
                                        <label class="form-label">Password</label>
                                        <div class="input-group input-group-merge">
                                            <input :type="showPassword ? 'text' : 'password'" v-model="password" class="form-control" required placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password" />
                                            <span class="input-group-text cursor-pointer"><i :class="showPassword ? 'bx bx-hide' : 'bx bx-show'"  @click="togglePassword"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="mb-3 form-password-toggle">
                                        <label class="form-label">Confirm Password</label>
                                        <div class="input-group input-group-merge">
                                            <input :type="showConfimPassword ? 'text' : 'password'" v-model="confirmpassword" required class="form-control" placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="confirmpassword" />
                                            <span class="input-group-text cursor-pointer"><i :class="showConfimPassword ? 'bx bx-hide' : 'bx bx-show'"  @click="toggleConfirmPassword"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <button class="btn btn-info d-grid w-100">Save</button>
                            <div v-if="isError" class="alert alert-danger mt-3" role="alert">
                                {{ errorMessage }}
                            </div>
                        </form>

                    </div>
                    

                </div>
            </div>
        
    </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                planCode: 'SWPCORE',
                sitename:'',
                password: '',
                confirmpassword: '',
                showPassword: false,
                showConfimPassword: false,
                isError: false,
                errorMessage: 'Invalid. Please try again.',
                isLoading: false
            };
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword;
            },
            toggleConfirmPassword() {
                this.showConfimPassword = !this.showConfimPassword;
            },
            validateForm() {
                this.errors = {};
                const alphanumericRegex = /^[a-zA-Z0-9]*$/;
                
                if (!this.sitename) {
                    this.errorMessage = this.errors.sitename = 'Site Name is required';
                }
                else if (!alphanumericRegex.test(this.sitename)) {
                    this.errorMessage = this.error = 'Site Name must be alphanumeric characters only.';
                }
                else if (this.sitename.length < 3) {
                    this.errorMessage = this.errors.sitename = 'Site Name must be at least 3 characters';
                }

                if (!this.password) {
                    this.errorMessage = this.errors.password = 'Password is required';
                }
                else if (this.password.length < 8) {
                    this.errorMessage = this.errors.password = 'Password must be at least 8 characters';
                }
                else if (this.password != this.confirmpassword) {
                    this.errorMessage = this.errors.password = 'Password not match';
                }

                return Object.keys(this.errors).length === 0;
            },
            async checkWebsite() {
                try {
                    const res = await axios.post('https://' + this.sitename + '.safeworkpro.com/api/show_disk_usage');
                    return false;
                } catch (err) {
                    return true;
                }
            },
            async createSubscription() {
                const customerId = localStorage.getItem('customerId');
                axios.post('/api/zoho/subscription', 
                    {
                        "customer_id": customerId,
                        "plan": {
                            "plan_code": this.planCode,
                            "quantity": "1",
                            "plan_description": this.sitename + '.safeworkpro.com'
                        },
                        "payment_terms": 0,
                        "payment_terms_label": "Due on Receipt",
                        "auto_collect": false,
                        "payment_gateways": [{
                            "payment_gateway": "stripe"
                        }],
                        "password": this.password
                    })
                .then((response) => {
                    console.log(response);
                    const data = response.data;
                    if(data.status == 'success'){
                        this.$router.push('/dashboard'); // Redirect to the dashboard
                        
                    }
                    else{
                        this.isLoading = false;
                        this.isError = true;
                        this.errorMessage = data.message;
                    }
                    
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.isError = true;
                    this.errorMessage = error.response.message || 'Adding subscription failed. Try again.';
                });
                
            },
            async addSubscription() { 
                this.isLoading = true;
                if (this.validateForm()) {
                    let isSiteValid = await this.checkWebsite()
                    if(isSiteValid){
                        this.createSubscription();
                    }
                    else{
                        this.errorMessage = 'Site name already exist';
                        this.isError = true;
                        this.isLoading = false;
                    }
                }
                else {
                    this.isError = true;
                    this.isLoading = false;
                }
                
            },

        },
    };
</script>

<style scoped>
    .loader-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        background-color: #fff;
    }

    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>